import * as React from 'react';
import { useSelector } from 'react-redux';

import { EtazhiBlackFridayPromoOffers } from '../EtazhiBlackFridayPromoOffers';
import { EtazhiBlackFridayTopBanner } from '../EtazhiBlackFridayTopBanner';
import { useGetOffersPrices, useGetPromoOffers, useIsEnabledByRegion, usePromoOffersVisibility } from './hooks';
import {
  selectEtazhiBlackFridayIsEnabledByRegion,
  selectEtazhiBlackFridayPromoOffersData,
  selectIsEtazhiBlackFridayFilterEnabled,
} from 'shared/selectors/etazhiBlackFriday';
import { getIsStartDatePassed } from 'shared/utils/etazhiBlackFriday';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export const EtazhiBlackFridayPromotion: React.FC = () => {
  const { isEnabledByRegionFetched } = useIsEnabledByRegion();

  const isEnabledByRegion = useSelector(selectEtazhiBlackFridayIsEnabledByRegion);
  const isBlackFridayFilterEnabled = useSelector(selectIsEtazhiBlackFridayFilterEnabled);
  const promoOffersData = useSelector(selectEtazhiBlackFridayPromoOffersData);

  const isPromoOffersVisible = usePromoOffersVisibility();
  const { isFetched, hasData } = useGetPromoOffers(isPromoOffersVisible, isEnabledByRegionFetched);
  const isStartDatePassed = getIsStartDatePassed(promoOffersData);

  useGetOffersPrices(isPromoOffersVisible);

  /**
   * Вкл. фильтр ЧП - не показываем ни полку, ни баннер.
   */
  if (isBlackFridayFilterEnabled) {
    return null;
  }

  /**
   * Во время прогрева всегда показываем баннер
   * После прогрева показываем "полку" (если есть офферы) и баннер только если акция активна в регионе
   */
  if (isStartDatePassed && !isEnabledByRegion) {
    return null;
  }

  /**
   * "Полка" видна, но данные ещё не загружены - не показываем "полку".
   */
  if (isPromoOffersVisible && !isFetched) {
    return null;
  }

  /**
   * "Полка" видна, данные загружены и не пустые - показываем полку.
   */
  if (isPromoOffersVisible && isFetched && hasData) {
    return <EtazhiBlackFridayPromoOffers />;
  }

  return <EtazhiBlackFridayTopBanner isButtonVisible={isPromoOffersVisible} />;
};
